var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progress-component"},[_c('div',{staticClass:"progress-component__wrapper"},[_c('p',{staticClass:"progress-component__text"},[_vm._v(_vm._s(_vm.$gettext('Loading')))])])])}
var staticRenderFns = []

export { render, staticRenderFns }